<template>
  <el-dialog class="crmFmAgentDetails" :close-on-click-modal="false" title="" :visible.sync="dialogVisible">
    <div>
      <base-info-form ref="baseInfo" :value="baseInfo" :isReadOnly="true" :isComShow="true" :isShowAgentCode="true"></base-info-form>

      <!--联系人信息-->
      <contact-form ref="contact" :value="contact" :isReadOnly="true"></contact-form>
      <!--联系人信息_end-->
      <!--代理信息-->

      <div v-if="agentList.length>0">
        <h6 class="ptitle">代理信息</h6>
        <agent-info v-for="(agent, index) of agentList" :ref="'agentInfo' + (index+1)" :value="agent" :myIndex="(index+1)" @delAgentfn="delAgentfn" :isReadOnly="true" :isHideContractNumber="false" :isHideAgentLevel="false"></agent-info>
      </div>
      <!--代理信息_end-->

      <!--金额-->
      <!-- <agentMoney ref="refAgentMoney" :isReadOnly="true" :value="agentMoney"></agentMoney> -->
      <!--金额_end-->

      <!--收货信息-->
      <!--<agent-address ref="address" :value="address" :isReadOnly="true"></agent-address>-->
      <!--收货信息_end-->

      <!--业务情况-->
      <!-- <business-form ref="business" :value="business" :isReadOnly="true"></business-form> -->
      <!--业务情况_end-->

      <!-- <div class="cut-line"></div>
      <agentOtherInfo1 ref="refagentOtherInfo1"></agentOtherInfo1> -->

    </div>
    <el-row>
      <el-col :span="24" style="display: flex;justify-content: center;margin-bottom: 15px">
        <el-button @click="closeDialog">我知道了</el-button>
      </el-col>
    </el-row>

  </el-dialog>
</template>
<script>
import { GetByAgentId, GetNewByAgentId } from "@api/agentApi.js";
import NProgress from "nprogress";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";
import $http from "$http";

//组件
import baseInfoForm from "agent-base-info";
import contactForm from "agent-contact";
import agentInfo from "agent-info";
import businessForm from "@pages/CRMAgentManage/components/business-form/index.vue";
import agentMoney from "components/agent-money/index.vue";
import agentOtherInfo1 from "components/agent-other-info1/index.vue";
//import agentSignMaterielv from 'agent-sign-materiel';
//import address from 'agent-address';

export default {
  props: {
    Id: {
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      agentList: [],
      baseInfo: null,
      contact: null,
      agentMoney: null,
      //address: null,
      business: null
      //materiel: null
    };
  },
  components: {
    "base-info-form": baseInfoForm,
    "contact-form": contactForm,
    "agent-info": agentInfo,
    //'agent-address': address,
    "business-form": businessForm,
    agentMoney,
    agentOtherInfo1
    //'agent-sign-materielv': agentSignMaterielv
  },
  methods: {
    showDialog(AgentId) {
      this.loadData(AgentId);
    },
    addAgentObj() {
      this.agentList.push({});
    },
    addAgent() {
      this.agentInfoNum += 1;
    },
    delAgentfn(item) {
      //alert(item.index);
      this.agentList.splice(item.index - 1, 1);
    },
    getList() {
      let param = {
        Sid: this.sysSid,
        Session: this.sysSession,
        Id: this.$route.query.Id
      };
      GetERP_OrderById(param).then(res => {
        util.doResult(this, res, () => {
          this.form = res.data.Data;
          if (this.form.SendGoods.length > 0) {
            this.IsShow = true;
          } else {
            this.IsShow = false;
          }
        });
      });
    },
    closeDialog() {
      //util.redirect(this, "/Order/SaleOrder", false);
      //window.history.go(-1);
      this.dialogVisible = false;
      this.$refs.refagentOtherInfo1.resetFields();
    },
    loadData(AgentId) {
      let _session = util.getSessin();
      let param = {
        Sid: _session[0],
        Session: _session[1],
        AgentId: AgentId
      };

      let $message = this.$message({
        showClose: false,
        message: "正在获取数据中",
        duration: 0
      });

      $http.get("api/Agent/GetNewByAgentId", param).then(res => {
        let { Data } = res.data;
        $message.close();
        util.doResult(this, res, () => {
          this.dialogVisible = true;
          this.$nextTick(() => {
            this.baseInfo = util.filterAndSetData(
              this.$refs.baseInfo.refsGetInitData(),
              Data
            );
            this.contact = util.filterAndSetData(
              this.$refs.contact.getInitResultData(),
              Data
            );
            this.business = util.filterAndSetData(
              this.$refs.business.refGetFormData(),
              Data
            );
            this.agentList = Data.SignList;
            this.agentMoney = this.$refs.refAgentMoney.getRefInitFormData(Data);
            this.$refs.refagentOtherInfo1.setValue(Data);
          });
        });
      });
    }
  },
  created() {
    //this.loadData();
  }
};
</script>

<style scoped lang="scss">
.ptitle {
  font-size: 17px;
  font-weight: bold;
}

span {
  margin-left: 25px;
}

.show-img-cell {
  border: 1px solid #ccc;
}

.cut-line {
  height: 12px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 36px;
}
</style>


// WEBPACK FOOTER //
// crm-form-agent-details.vue?862ceb76